const PERFIS_SISTEMA = new Set(['super_admin', 'super_admin_assistente']);
const PERFIS_ADMIN_CRECHE = new Set(['gestor', 'gestor_assistente', 'administrativo', 'admin']);
const PERFIS_RESTRITOS = new Set(['professor', 'responsavel']);

const ROTAS_SISTEMA = new Set([
  '/app',
  '/app/sistema',
  '/app/creches',
  '/app/usuarios',
  '/app/alunos',
  '/app/familias',
  '/app/funcionarios',
  '/app/pedagogico',
  '/app/administrativo',
  '/app/infraestrutura',
  '/app/seguranca',
  '/app/saude',
  '/app/ia',
  '/app/relatorios',
  '/app/turmas',
  '/app/salas',
  '/app/demanda',
  '/app/visitas',
  '/app/secretaria',
  '/app/financeiro',
  '/app/cardapios',
  '/app/nutricao',
  '/app/calendario',
  '/app/comunicacao',
  '/app/atendimentos',
  '/app/rotina',
  '/app/presenca',
  '/app/meu-painel',
  '/app/pagina-publica',
  '/app/importar',
]);

const ROTAS_ADMIN_CRECHE = new Set([
  '/app',
  '/app/usuarios',
  '/app/alunos',
  '/app/familias',
  '/app/funcionarios',
  '/app/pedagogico',
  '/app/administrativo',
  '/app/infraestrutura',
  '/app/seguranca',
  '/app/saude',
  '/app/ia',
  '/app/relatorios',
  '/app/turmas',
  '/app/salas',
  '/app/demanda',
  '/app/visitas',
  '/app/secretaria',
  '/app/financeiro',
  '/app/cardapios',
  '/app/nutricao',
  '/app/calendario',
  '/app/comunicacao',
  '/app/atendimentos',
  '/app/rotina',
  '/app/presenca',
  '/app/meu-painel',
  '/app/pagina-publica',
  '/app/importar',
]);

/**
 * Professor e responsável eram os dois "restritos" e dividiam UMA lista de
 * rotas — o que impedia dar presença ao professor sem dar a mesma tela ao pai.
 * São papéis diferentes: um trabalha na creche, o outro é família.
 *
 * O professor recebe `/app/presenca` porque é ele quem faz a chamada, com a
 * turma na frente. O backend escopa tudo à turma dele (PresencaService); esta
 * lista é conveniência de navegação, nunca a fronteira de segurança.
 */
const ROTAS_PROFESSOR = new Set([
  '/app', '/app/alunos', '/app/rotina', '/app/presenca', '/app/meu-painel',
  // Aceitacao alimentar: quem serve o prato e quem ve a crianca comer. O
  // NutricaoService escopa a turma dele; esta lista e navegacao, nao fronteira.
  '/app/nutricao',
]);

const ROTAS_RESPONSAVEL = new Set(['/app', '/app/meu-filho', '/app/alunos', '/app/rotina']);

export function normalizarPerfil(tipoUsuario?: string) {
  return String(tipoUsuario || '').toLowerCase().trim();
}

export function ehPerfilRestrito(tipoUsuario?: string) {
  return PERFIS_RESTRITOS.has(normalizarPerfil(tipoUsuario));
}

export function ehAdminSistema(tipoUsuario?: string) {
  return PERFIS_SISTEMA.has(normalizarPerfil(tipoUsuario));
}

export function podeAcessarRota(tipoUsuario: string | undefined, rota: string) {
  const perfil = normalizarPerfil(tipoUsuario);
  const base = String(rota || '').split('?')[0].replace(/\/$/, '');
  const normalizedRoute = base || '/app';

  if (PERFIS_SISTEMA.has(perfil)) {
    return ROTAS_SISTEMA.has(normalizedRoute);
  }

  if (PERFIS_ADMIN_CRECHE.has(perfil)) {
    return ROTAS_ADMIN_CRECHE.has(normalizedRoute);
  }

  if (perfil === 'professor') {
    return ROTAS_PROFESSOR.has(normalizedRoute);
  }

  if (perfil === 'responsavel') {
    return ROTAS_RESPONSAVEL.has(normalizedRoute);
  }

  return false;
}

export function rotaInicialPorPerfil(tipoUsuario?: string) {
  const perfil = normalizarPerfil(tipoUsuario);
  if (PERFIS_SISTEMA.has(perfil)) return '/app/sistema';
  if (PERFIS_ADMIN_CRECHE.has(perfil)) return '/app';
  if (perfil === 'responsavel') return '/app/meu-filho';
  // Professor entra na ROTINA: é o trabalho do dia. O painel dele é consulta,
  // não ponto de partida.
  if (PERFIS_RESTRITOS.has(perfil)) return '/app/rotina';
  return '/login';
}
